




import {Component, Ref, Vue} from "vue-property-decorator";
import PriorityRule from "@/pages/Pages/Rules/PriorityRule.vue";
import {MsgTransports} from "@/store/types";

Component.registerHooks([
  'beforeRouteLeave',
])

@Component({components: {PriorityRule}})
export default class SmsPriorityRule extends Vue{
  @Ref('priorityRule') priorityRule: any;
  private smsTransport: MsgTransports = MsgTransports.SMS

  beforeRouteLeave(to:any, from:any, next:any) {
    this.priorityRule.beforeLeave(to,from,next)
  }
}
